module.exports = __webpack_public_path__ + "files/0e861c0e3a9ffb4460fac18b91469cac.png";